<template>
  <vue-editor
    v-if="richText"
    :value="value"
    :editorOptions="editorOptions"
    :disabled="disabled"
    :class="editorClasses"
    @input="$emit('input', $event)"
  />
  <textarea
    v-else
    :id="id"
    :value="value"
    :placeholder="placeholder"
    :rows="rows"
    :disabled="disabled"
    :readonly="readonly"
    :class="textareaClasses"
    :aria-invalid="ariaInvalid"
    :aria-describedby="ariaDescribedby"
    :aria-required="ariaRequired"
    v-bind="$attrs"
    @input="handleInput"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  />
</template>

<script>
import { VueEditor } from 'vue2-editor';

export default {
  name: 'ThemedTextarea',
  components: {
    VueEditor
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    rows: {
      type: Number,
      default: 4
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    richText: {
      type: Boolean,
      default: false
    },
    editorOptions: {
      type: Object,
      default: () => ({
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['link'],
            ['clean']
          ]
        },
        placeholder: 'Enter text...'
      })
    },
    ariaInvalid: {
      type: String,
      default: null
    },
    ariaDescribedby: {
      type: String,
      default: null
    },
    ariaRequired: {
      type: String,
      default: null
    }
  },
  computed: {
    textareaClasses() {
      return [
        'themed-textarea',
        {
          'themed-textarea--error': this.error,
          'themed-textarea--readonly': this.readonly,
          'themed-textarea--disabled': this.disabled
        }
      ];
    },
    editorClasses() {
      const baseClasses = 'themed-textarea-editor';
      
      const stateClasses = [];
      
      if (this.error) {
        stateClasses.push('themed-textarea-editor--error');
      }
      
      if (this.disabled) {
        stateClasses.push('themed-textarea-editor--disabled');
      }
      
      return this.cn(baseClasses, ...stateClasses);
    }
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value);
    }
  }
}
</script>
